<template>
  <div class="value-display-box" :style="boxStyle">
    <span class="display-text">{{ text }}</span>
    <span class="display-value">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'ValueDisplayBox',
  props: {
    text: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    boxStyle() {
      const style = {};
      if (this.background) style.background = this.background;
      if (this.color) style.color = this.color;
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.value-display-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  box-sizing: border-box;
  width: 100%;
  // Match .primary-input text field size (padding + line-height + 1px border each side)
  min-height: calc(0.9rem + 0.65rem + 1.5em + 2px);
  padding: 0 0.7rem;
  border: none;
  border-radius: $borderRadius4;
  background: $appBackgroundColor;
  font-size: $fontSize14;
  line-height: 1.5;
  color: $textColor87;
}

.display-text,
.display-value {
  white-space: nowrap;
}

.display-text {
  text-align: left;
}

.display-value {
  text-align: right;
  margin-left: auto;
  font-weight: 600;
}
</style>
